/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2017 - 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'../../../lib/@waca/dashboard-common/dist/core/Model',
	'./shaping/ShapingModel',
	'underscore'
], (Model, ShapingModel, _) => {
	'use strict';

	const SourceModel = Model.extend({
		nestedModels: {
			shaping: ShapingModel
		},

		whitelistAttrs: ['id', 'assetId', 'type', 'clientId', 'module', 'name', 'pinSourceName', 'shaping', 'customGroupColumns'],

		init: function (model) {
			if (model) {
				_.defaults(model, {
					shaping: {},
					assetId: this._generateUniqueId('assetId')
				});
			}
			SourceModel.inherited('init', this, arguments);
		},

		destroy: function () {
			if (this.getTempModuleUrl() && this.ajaxSvc) {
				this.ajaxSvc.ajax({
					contentType: 'application/json; charset=utf-8',
					url: this.getTempModuleUrl(),
					type: 'DELETE'
				});
			}
			this.get('shaping').destroy();
		},

		setAjaxSvc: function (ajaxSvc) {
			this.ajaxSvc = ajaxSvc;
		},

		setUserProfileSvc: function (userProfileSvc) {
			this.userProfileSvc = userProfileSvc;
		},

		getDeploymentReference: function (deploymentReferences, processedAssetIds, isSaveAs) {
			if (this.state !== 'error' && this.errorCode !== '404') {
				const userPreferences = this.userProfileSvc && this.userProfileSvc.preferences;
				const contentLocale = userPreferences && userPreferences.contentLocale || 'en-us';
				if(!processedAssetIds[this.assetId]) {
					processedAssetIds[this.assetId] = true;
					deploymentReferences.push({
						objects: [{
							type: this.type,
							searchPath: `storeID("${this.assetId}")`
						}],
						name: {
							[contentLocale]: this.assetId
						}
					});
				}
				if (this.shaping) {
					this.shaping.getDeploymentReference(deploymentReferences, processedAssetIds, isSaveAs, contentLocale);
				}
			}
		},

		getIsOlapPackage: function () {
			return this.get('isOlapPackage');
		},

		hasInlineModule: function () {
			return typeof this.module !== 'undefined';
		},

		setTempModuleUrl: function (url) {
			this._tempModuleUrl = url;
		},

		getTempModuleUrl: function () {
			return this._tempModuleUrl;
		}
	});

	return SourceModel;
});
